import React, { useEffect, useState } from 'react';
import { Box, Typography, Container, CircularProgress, Grid } from '@mui/material';
import ProfileProviderCard from './ProfileProviderCard';
import Carrusel from '../../common/Carrusel';
import { getTopProviders } from '../../../actions/profile';

const ProfileProvidersList = ({ currentUserId }) => {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Una respuesta que llega cuando ya se ve otro perfil no reemplaza a la de ese perfil
    let vigente = true;
    const fetchProviders = async () => {
      try {
        // Para el perfil que se está viendo: primero los de sus categorías
        const topProviders = await getTopProviders(currentUserId);
        // Filtrar el proveedor actual (el servidor ya no lo manda; uno sin actualizar, sí)
        const filtered = topProviders.filter(p => p.user !== currentUserId);
        if (vigente) setProviders(filtered);
      } catch (error) {
        console.error("Failed to fetch top providers:", error);
      } finally {
        if (vigente) setLoading(false);
      }
    };
    fetchProviders();
    return () => { vigente = false; };
  }, [currentUserId]);

  if (loading) {
    return (
      <Grid container justifyContent="center" sx={{ my: 6 }}>
        <CircularProgress />
      </Grid>
    );
  }

  // If no providers are returned, we simply don't render the section.
  if (providers.length === 0) return null;

  return (
    <Box sx={{ mt: 8 }}>
      <Grid container justifyContent="space-between" alignItems="flex-end" sx={{ mb: 4 }}>
        <Box>
          <Typography variant="h5" fontWeight="bold" color="primary" sx={{ mb: 0.5 }}>
            Perfiles de proveedores
          </Typography>
          <Typography variant="body2" color="text.secondary">
            que creemos podrían interesarte
          </Typography>
        </Box>
        {/* <Typography
            variant="body2"
            color='primary'
            sx={{
              fontWeight: 'bold',
              cursor: 'pointer',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Mostrar los {providers.reduce((acc, p) => acc + p.serviceCount, 0)} servicios
          </Typography> */}
      </Grid>

      {/* El carrusel de «Servicios destacados»: de 1 a 4 tarjetas por fila según el ancho, con flechas a los lados. Con aire arriba para
          que la tarjeta que se levanta al pasar el mouse no se corte, y abajo para su sombra */}
      <Carrusel etiquetas={['Proveedores anteriores', 'Más proveedores']} style={{ paddingTop: 4, paddingBottom: 24 }}>
        {providers.map((profile, index) => (
          <ProfileProviderCard key={profile.user || index} profile={profile} />
        ))}
      </Carrusel>
    </Box>
  );
};

export default ProfileProvidersList;
